"use client";

import Image from "next/image";
import YouTube from "react-youtube";
import { Vector } from "@/components/ui/vector";
import { useVideo, UseVideoProps } from "./use-video";
import { Typography } from "@/components/ui";

export type VideoProps = UseVideoProps;

export const Video = (props: VideoProps) => {
  const {
    className,
    styles,
    ref,
    opts,
    onClick,
    onPlay,
    onEnd,
    title,
    videoId,
    cover,
  } = useVideo(props);

  return (
    <div className={styles.base({ className })} onClick={onClick}>
      <div className={styles.figure()}>
        <div className={styles.caption()}>
          <Typography
            className={styles.title()}
            as="h2"
            fontFamily="chillen"
            fontSize="heading-lg"
            uppercase
          >
            {title}
          </Typography>
          <span className={styles.button()}>
            <Vector name="play" className={styles.icon()} />
          </span>
          <Typography
            className={styles.label()}
            fontSize="body-sm"
            fontWeight="bold"
            spacing="widest"
            uppercase
          >
            Assista ao vídeo
          </Typography>
        </div>
        <Image
          fill
          alt={title}
          src={cover}
          quality={100}
          sizes="100vw"
          className={styles.background()}
        />
      </div>
      <YouTube
        className={styles.player()}
        title={title}
        iframeClassName={styles.iframe()}
        videoId={videoId}
        opts={opts}
        onPlay={onPlay}
        onEnd={onEnd}
        ref={ref}
      />
    </div>
  );
};
